import React from 'react'
import Skeleton from 'react-loading-skeleton'

const SkeletonFriends = () => {
  return (
    <div className="rightbarFollowings">
        <div className="rightbarFollowing">
            <Skeleton className="rightbarFollowingImg" />
            <div className="w-100">
                <Skeleton className="skeletonRightbarFollowingName" />
            </div>
            <div className="w-100">
                <Skeleton className="skeletonRightbarFollowingName" />
            </div>
        </div>
        <div className="rightbarFollowing">
            <Skeleton className="rightbarFollowingImg" />
            <div className="w-100">
                <Skeleton className="skeletonRightbarFollowingName" />
            </div>
            <div className="w-100">
                <Skeleton className="skeletonRightbarFollowingName" />
            </div>
        </div>
        <div className="rightbarFollowing">
            <Skeleton className="rightbarFollowingImg" />
            <div className="w-100">
                <Skeleton className="skeletonRightbarFollowingName" />
            </div>
            <div className="w-100">
                <Skeleton className="skeletonRightbarFollowingName" />
            </div>
        </div>
        <div className="rightbarFollowing">
            <Skeleton className="rightbarFollowingImg" />
            <div className="w-100">
                <Skeleton className="skeletonRightbarFollowingName" />
            </div>
            <div className="w-100">
                <Skeleton className="skeletonRightbarFollowingName" />
            </div>
        </div>
        <div className="rightbarFollowing">
            <Skeleton className="rightbarFollowingImg" />
            <div className="w-100">
                <Skeleton className="skeletonRightbarFollowingName" />
            </div>
            <div className="w-100">
                <Skeleton className="skeletonRightbarFollowingName" />
            </div>
        </div>
        <div className="rightbarFollowing">
            <Skeleton className="rightbarFollowingImg" />
            <div className="w-100">
                <Skeleton className="skeletonRightbarFollowingName" />
            </div>
            <div className="w-100">
                <Skeleton className="skeletonRightbarFollowingName" />
            </div>
        </div>
    </div>
  )
}

export default SkeletonFriends